import React, { Component } from "react";
import ArrowBack from "@material-ui/icons/ArrowBack";
import BookmarkBorderOutlinedIcon from '@material-ui/icons/BookmarkBorderOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CreateIcon from '@material-ui/icons/Create';
import CloseIcon from '@material-ui/icons/Close';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import StarIcon from '@material-ui/icons/Star';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CircularProgress from '@material-ui/core/CircularProgress';
import Add from "@material-ui/icons/Add";
import Button from "../../components/CustomButtons/Button.jsx";
import Button2 from '@material-ui/core/Button';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import TextField from "@material-ui/core/TextField";
import { useSpring, animated } from "react-spring";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { red } from "@material-ui/core/colors";
import FavoriteBorderOutlined from "@material-ui/icons/FavoriteBorderOutlined";
import ChatBubbleOutline from "@material-ui/icons/ChatBubbleOutline";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Container from "@material-ui/core/Container";
import logo from "../../images/dut.png";
import phone from "../../images/phone.png";
import dutylogo from "../../images/dutylogo.png";
import addphoto from "../../images/addphoto.png";
import dutyConnect from "../../images/DutyConnect.jpeg";
import check from "../../images/check.png";
import dutyPlanner from "../../images/DutyPlanner.jpeg";
import dutyControl from "../../images/DutyControl.jpeg";
import { Link } from "react-router-dom";
import errorImg from "../../images/error.png";
import Grid from '@material-ui/core/Grid';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

const ExpansionPanel = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, .03)',
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiExpansionPanelDetails);

export default class EditarFormulario extends Component {
    constructor(props) {
        super(props);
        this.f = {
            formulario: []
        }
        this.state = {
            catdis: false,
            textdis: true,
            estdis: true,
            chedis: true,
            open1: false,
            open2: false,
            open3: false,
            op1: '',
            op2: '',
            op1c: false,
            op2c: false,
            cantEst: false,
            cantEst2: false,
            expanded: false,
            loading: false,
            load: false,
            nombreFormulario: 'LOCAL AUDITADO',
            textForm: '',
            estForm: '',
            cheForm: ''
        }
    }

    componentDidMount() {
        this.f.formulario = [
            {
                name: 'Mobiliario',
                items: [
                    {
                        name: 'Sillas',
                        type: 'estrella',
                        valor: 2,
                        valuable: 2
                    },
                    // {
                    //     name: 'Mesas',
                    //     type: 'check'
                    // },
                    // {
                    //     name: 'Sombrillas',
                    //     type: 'check'
                    // }
                ],
                id: 1
            },
            {
                name: 'Recepción',
                items: [
                    {
                        name: 'Limpieza',
                        type: 'estrella',
                        valor: 3,
                        valuable: 5
                    },
                    {
                        name: 'Folleteria',
                        type: 'texto',
                        valor: 'Esta completa con la informacion correcta.'
                    },
                    // {
                    //     name: 'PruebaLoco',
                    //     type: 'check',
                    //     items: [
                    //         {
                    //             name: 'Opcion A',
                    //             check: true
                    //         },
                    //         {
                    //             name: 'Opcion B',
                    //             check: false
                    //         }
                    //     ]
                    // }
                ],
                id: 2
            }
        ]
        this.setState({ loading: false })
    }

    _content = () => {
        return (
            <div style={{ justifyContent: 'flex-start' }}>
                <Grid container spacing={1} style={{ justifyContent: 'flex-start', alignItems: 'center', padding: 10, paddingBottom: 15 }}>
                    <Grid item xs={0} sm={1} style={{ width: '100%' }}></Grid>
                    <Grid item xs={12} sm={6} style={{ justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center', display: 'flex' }}>
                        <Typography className="novTit">Editar Formulario</Typography>
                        {/* <div style={{}}>
                            <Button
                                style={{ width: '100%', maxWidth: 150, height: 40, marginLeft: 20, backgroundColor: '#F50027', borderRadius: 7 }}
                                onClick={() => {
                                    this.setState({ open1: !this.state.open1 });
                                }}>
                                <Typography style={{ fontWeight: 600, fontFamily: 'Muli', fontSize: 14, paddingRight: 20, paddingLeft: 20 }}>GUARDAR</Typography>
                            </Button>
                        </div> */}
                    </Grid>
                </Grid>
            </div>
        )
    }
    _subContent = () => {
        return (
            <div>
                <Grid container spacing={3} style={{ flexDirection: 'row', display: 'flex', padding: 10 }}>
                    <Grid item xs={0} sm={1} style={{ width: '100%' }}></Grid>
                    <Grid item xs={12} sm={6} style={{ width: '100%' }}>
                        <Card style={{ flexDirection: 'column', width: '100%', alignItems: 'flex-start', display: 'flex', borderRadius: 10 }}>
                            <CardContent>
                                <Link to="/auditorias">
                                    <ArrowBack className="btn1icon" />
                                </Link>
                            </CardContent>
                            <CardContent style={{ width: '100%', paddingTop: 0 }}>
                                <div style={{ width: "100%" }}>
                                    <TextField
                                        id="standard-name"
                                        label="Nombre del formulario"
                                        style={{ width: "100%", marginTop: 0, marginBottom: 0, fontSize: 16 }}
                                        value={this.state.tit}
                                        inputProps={{
                                            onChange: e => {
                                                this.setState({ nombreFormulario: e.target.value });
                                            },
                                            type: "text"
                                        }}
                                        margin="normal"
                                    />
                                </div>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={10} sm={3} style={{ alignItems: 'center', margin: window.innerWidth < 600 ? 'none' : 'initial', width: '100%', display: window.innerWidth < 992 ? 'none' : 'block' }}>
                        <div style={{ marginLeft: 'auto', marginRight: 'auto', justifyContent: 'center' }}>
                            <div style={{ position: 'relative', display: 'flex' }}>
                                <img src={phone} style={{ width: '100%', position: 'absolute', zIndex: 5 }} />
                            </div>
                            <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                                <Card style={{ width: '80%', alignItems: 'center', marginTop: 20 }}>
                                    <CardContent style={{ width: '100%', height: 60, justifyContent: 'space-between', flexDirection: 'row', display: 'flex', alignItems: 'flex-end', padding: 10 }}>
                                        <ArrowBack className="btn1icon" style={{ height: 17 }} />
                                        <Button2
                                            variant="outlined"
                                            color="secondary"
                                            style={{ margin: 0, padding: 2, alignItems: 'center', width: '100%', maxWidth: 50, height: 20, borderColor: '#F50027', backgroundColor: '#fff' }}>
                                            <Typography style={{ textTransform: 'capitalize', fontWeight: 100, fontFamily: 'Muli', fontSize: 8, textAlign: 'center', alignItems: 'center', color: '#F50027' }}>Guardar</Typography>
                                        </Button2>
                                    </CardContent>
                                </Card>
                            </div>
                            {
                                this.state.load
                                    ?
                                    <div>
                                        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                                            <div style={{ backgroundColor: '#d7d7d7', width: '80%', padding: 10, paddingLeft: 20 }}>
                                                <Typography style={{ textTransform: 'uppercase', fontWeight: 800, fontFamily: 'Muli', fontSize: 12, textAlign: 'left', alignItems: 'center', color: '#000' }}>{this.state.nombreFormulario}</Typography>
                                            </div>
                                        </div>
                                        <div style={{ position: 'absolute', display: 'flex', justifyContent: 'center', flexDirection: 'column', marginLeft: '10%', marginTop: '10%' }}>
                                            <CircularProgress size={30} color="secondary" />
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                                            <div style={{ backgroundColor: '#d7d7d7', width: '80%', padding: 10, paddingLeft: 20 }}>
                                                <Typography style={{ textTransform: 'uppercase', fontWeight: 800, fontFamily: 'Muli', fontSize: 12, textAlign: 'left', alignItems: 'center', color: '#000' }}>{this.state.nombreFormulario}</Typography>
                                            </div>
                                        </div>
                                        <div style={{ position: 'absolute', display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', marginLeft: 30, width: '21%' }}>
                                            {
                                                this.f.formulario.map((item, i) => {
                                                    return (
                                                        <div style={{ width: '100%' }}>
                                                            <div style={{ backgroundColor: '#f3f3f3', width: '90%', padding: 10, paddingLeft: 20 }}>
                                                                <Typography style={{ textTransform: 'capitalize', fontWeight: 600, fontFamily: 'Muli', fontSize: 10, textAlign: 'left', alignItems: 'center', color: '#4d4d4d' }}>{item.name}</Typography>
                                                            </div>
                                                            {
                                                                item.items
                                                                    ?
                                                                    item.items.map((item2, l) => {
                                                                        return (
                                                                            <div style={{ borderBottomWidth: 1, borderBottomColor: '#ababab' }}>
                                                                                <div style={{ backgroundColor: '#fff', width: '90%', padding: 5, paddingLeft: 20 }}>
                                                                                    <Typography style={{ textTransform: 'capitalize', fontWeight: 600, fontFamily: 'Muli', fontSize: 10, textAlign: 'left', alignItems: 'center', color: '#4d4d4d' }}>{item2.name}</Typography>
                                                                                </div>
                                                                                {this._types(item2)}
                                                                                {this._types2(item2)}
                                                                            </div>
                                                                        )
                                                                    })
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                            }
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }
    _cardAdd = () => {
        if (window.innerWidth > 600) {
            return (
                <Grid item xs={0} sm={7} style={{ width: '100%', padding: 0 }}>
                    <div style={{ flexDirection: 'row', justifyContent: 'around', width: '100%', display: 'flex' }}>
                        <div style={{ width: '15%' }}></div>
                        <div style={{ paddingLeft: 5, paddingRight: 5, width: '21%' }}>
                            <Card style={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center', display: 'flex', borderRadius: 10, backgroundColor: this.state.catdis ? '#e8e8e8' : '#fff' }}>
                                <CardActionArea
                                    onClick={() => {
                                        this.setState({ open1: !this.state.open1 });
                                    }}
                                    disabled={this.state.catdis}
                                    style={{ padding: 5 }}>
                                    <CardContent style={{ width: '100%' }}>
                                        <BookmarkBorderOutlinedIcon style={{ color: '#959595', fontSize: 40 }} />
                                        <Typography style={{ color: '#959595', fontSize: 10, fontFamily: 'Muli' }}>CATEGORÍA</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </div>
                        <div style={{ paddingLeft: 5, paddingRight: 5, width: '21%' }}>
                            <Card style={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center', display: 'flex', borderRadius: 10, backgroundColor: this.state.textdis ? '#e8e8e8' : '#fff' }}>
                                <CardActionArea
                                    onClick={() => {
                                        this.setState({ open2: !this.state.open2 });
                                    }}
                                    disabled={this.state.textdis}
                                    style={{ padding: 5 }}>
                                    <CardContent style={{ width: '100%' }}>
                                        <TextFieldsIcon style={{ color: '#959595', fontSize: 40 }} />
                                        <Typography style={{ color: '#959595', fontSize: 10, fontFamily: 'Muli' }}>TEXTO</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </div>
                        <div style={{ paddingLeft: 5, paddingRight: 5, width: '21%' }}>
                            <Card style={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center', display: 'flex', borderRadius: 10, backgroundColor: this.state.estdis ? '#e8e8e8' : '#fff' }}>
                                <CardActionArea
                                    onClick={() => {
                                        this.setState({ open3: !this.state.open3 });
                                    }}
                                    disabled={this.state.estdis}
                                    style={{ padding: 5 }}>
                                    <CardContent style={{ width: '100%' }}>
                                        <StarBorderIcon style={{ color: '#959595', fontSize: 40 }} />
                                        <Typography style={{ color: '#959595', fontSize: 10, fontFamily: 'Muli' }}>ESTRELLA</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </div>
                        <div style={{ paddingLeft: 5, paddingRight: 5, width: '21%' }}>
                            <Card style={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center', display: 'flex', borderRadius: 10, backgroundColor: this.state.chedis ? '#e8e8e8' : '#fff' }}>
                                <CardActionArea
                                    onClick={() => {
                                        this.setState({ open4: !this.state.open4 });
                                    }}
                                    disabled={this.state.chedis}
                                    style={{ padding: 5 }}>
                                    <CardContent style={{ width: '100%' }}>
                                        <CheckCircleOutlineIcon style={{ color: '#959595', fontSize: 40 }} />
                                        <Typography style={{ color: '#959595', fontSize: 10, fontFamily: 'Muli' }}>MULTIPLECHOICE</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </div>
                    </div>
                </Grid>
            )
        }
    }
    _cardAddmob = () => {
        if (window.innerWidth < 600) {
            return (
                <div>
                    <Grid container spacing={0} style={{ marginTop: 10 }}>
                        <Grid item xs={0} sm={1} style={{ width: '100%', padding: 0 }}></Grid>
                        <Grid item xs={6} sm={2} style={{ padding: 15, paddingLeft: 30, paddingRight: 30 }}>
                            <Card style={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center', display: 'flex', borderRadius: 10, backgroundColor: this.state.catdis ? '#e8e8e8' : '#fff' }}>
                                <CardActionArea
                                    onClick={() => {
                                        this.setState({ open1: !this.state.open1 });
                                    }}
                                    disabled={this.state.catdis}>
                                    <CardContent style={{ width: '100%' }}>
                                        <BookmarkBorderOutlinedIcon style={{ color: '#959595', fontSize: 40 }} />
                                        <Typography style={{ color: '#959595', fontSize: 10, fontFamily: 'Muli' }}>CATEGORÍA</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                        <Grid item xs={6} sm={2} style={{ padding: 15, paddingLeft: 30, paddingRight: 30 }}>
                            <Card style={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center', display: 'flex', borderRadius: 10, backgroundColor: this.state.textdis ? '#e8e8e8' : '#fff' }}>
                                <CardActionArea
                                    onClick={() => {
                                        this.setState({ open2: !this.state.open2 });
                                    }}
                                    disabled={this.state.textdis}>
                                    <CardContent style={{ width: '100%' }}>
                                        <TextFieldsIcon style={{ color: '#959595', fontSize: 40 }} />
                                        <Typography style={{ color: '#959595', fontSize: 10, fontFamily: 'Muli' }}>TEXTO</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                        <Grid item xs={6} sm={2} style={{ padding: 15, paddingLeft: 30, paddingRight: 30 }}>
                            <Card style={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center', display: 'flex', borderRadius: 10, backgroundColor: this.state.estdis ? '#e8e8e8' : '#fff' }}>
                                <CardActionArea
                                    onClick={() => {
                                        this.setState({ open3: !this.state.open3 });
                                    }}
                                    disabled={this.state.estdis}>
                                    <CardContent style={{ width: '100%' }}>
                                        <StarBorderIcon style={{ color: '#959595', fontSize: 40 }} />
                                        <Typography style={{ color: '#959595', fontSize: 10, fontFamily: 'Muli' }}>ESTRELLA</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                        <Grid item xs={6} sm={2} style={{ padding: 15, paddingLeft: 30, paddingRight: 30 }}>
                            <Card style={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center', display: 'flex', borderRadius: 10, backgroundColor: this.state.chedis ? '#e8e8e8' : '#fff' }}>
                                <CardActionArea
                                    onClick={() => {
                                        this.setState({ open4: !this.state.open4 });
                                    }}
                                    disabled={this.state.chedis}>
                                    <CardContent style={{ width: '100%' }}>
                                        <CheckCircleOutlineIcon style={{ color: '#959595', fontSize: 40 }} />
                                        <Typography style={{ color: '#959595', fontSize: 10, fontFamily: 'Muli' }}>MULTIPLECHOICE</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    </Grid>
                </div>
            )
        }
    }

    // _gridFinal = () => {
    //     return (
    //         <Grid item xs={10} sm={3} style={{ alignItems: 'center', margin: window.innerWidth < 600 ? 'auto' : 'initial', width: '100%', display: window.innerWidth < 900 ? 'none' : 'block' }}>
    //             <div style={{ marginLeft: 'auto', marginRight: 'auto', justifyContent: 'center' }}>
    //                 <div style={{ position: 'relative', display: 'flex' }}>
    //                     <img src={phone} style={{ width: '100%', position: 'absolute', zIndex: 5 }} />
    //                 </div>
    //                 <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
    //                     <Card style={{ width: '80%', alignItems: 'center', marginTop: 20 }}>
    //                         <CardContent style={{ width: '100%', height: 60, justifyContent: 'space-between', flexDirection: 'row', display: 'flex', alignItems: 'flex-end', padding: 10 }}>
    //                             <ArrowBack className="btn1icon" style={{ height: 17 }} />
    //                             <Button2
    //                                 variant="outlined"
    //                                 color="secondary"
    //                                 style={{ margin: 0, padding: 2, alignItems: 'center', width: '100%', maxWidth: 50, height: 20, borderColor: '#F50027', backgroundColor: '#fff' }}>
    //                                 <Typography style={{ textTransform: 'capitalize', fontWeight: 100, fontFamily: 'Muli', fontSize: 8, textAlign: 'center', alignItems: 'center', color: '#F50027' }}>Guardar</Typography>
    //                             </Button2>
    //                         </CardContent>
    //                     </Card>
    //                 </div>
    //             </div>
    //         </Grid>
    //     )
    // }

    // const[expanded, setExpanded] = React.useState('panel1');

    // const handleChange = panel => (event, newExpanded) => {
    //     setExpanded(newExpanded ? panel : false);
    // };

    _handleChange = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    _listSubCard = () => {
        return (
            <div>
                <Grid container>
                    <Grid item xs={0} sm={1} style={{ width: '100%' }}></Grid>
                    <Grid item xs={12} sm={6} style={{ padding: 12 }}>
                        {
                            this.f.formulario.map((item, i) => {
                                return (
                                    <ExpansionPanel rounded expanded={this.state[item.id + '_exp']} onChange={() => { this.setState({ [item.id + '_exp']: true }) }} style={{ backgroundColor: '#fafafa', borderWidth: 0, padding: 0 }}>
                                        <ExpansionPanelSummary style={{ backgroundColor: '#fafafa', borderWidth: 0, padding: 0 }} aria-controls="panel1d-content" id="panel1d-header">
                                            <Card style={{ justifyContent: 'space-between', flexDirection: 'row', width: '100%', alignItems: 'center', display: 'flex', borderRadius: 8, borderLeft: 'inset', borderLeftColor: '#007aff' }}>
                                                <CardContent style={{ width: '100%', justifyContent: 'space-between', flexDirection: 'row', display: 'flex', alignItems: 'center', paddingTop: 10, paddingBottom: 10 }}>
                                                    <Typography style={{ color: '#959595', fontSize: 14, fontFamily: 'Muli' }}>{item.name}</Typography>
                                                    {
                                                        this.state[item.id + '_exp']
                                                            ?
                                                            <KeyboardArrowDownIcon style={{ color: '#F50027', fontSize: 26 }} />
                                                            :
                                                            <ChevronRightIcon style={{ color: '#F50027', fontSize: 26 }} />
                                                    }
                                                </CardContent>
                                            </Card>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails style={{ padding: 0, paddingLeft: 40, justifyContent: 'flex-end', display: 'flex' }}>
                                            <div style={{ width: '90%', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                                {
                                                    item.items
                                                        ?
                                                        item.items.map((item2, l) => {
                                                            return (
                                                                <Card style={{
                                                                    justifyContent: 'space-between', flexDirection: 'row', width: '100%', alignItems: 'center', display: 'flex',
                                                                    borderRadius: 8, marginBottom: 10, borderLeft: 'inset',
                                                                    borderLeftColor: item2.type == 'check' ? '#ff7a00' : item2.type == 'texto' ? '#3cff00' : item2.type == 'estrella' ? '#aa00ff' : '#ababab'
                                                                }}>
                                                                    <CardContent style={{ width: '100%', justifyContent: 'space-between', flexDirection: 'row', display: 'flex', alignItems: 'center', paddingTop: 10, paddingBottom: 10, paddingRight: 20 }}>
                                                                        <Typography style={{ color: '#959595', fontSize: 14, fontFamily: 'Muli' }}>{item2.name}</Typography>
                                                                        <CreateIcon style={{ color: '#757575', fontSize: 16 }} />
                                                                    </CardContent>
                                                                </Card>
                                                            )
                                                        })
                                                        : null
                                                }
                                            </div>
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                )
                            })
                        }
                    </Grid>
                </Grid>
            </div>
        )
    }

    setModal = prop => {
        this.setState({ open1: prop });
    };

    _modal = () => {
        return (
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                className={useStyles.modal}
                open={this.state.open1}
                style={{ overflow: "scroll" }}
                onClose={() => {
                    this.setModal(false);
                }}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500
                }}
            >
                <Card style={{ margin: "auto", marginTop: '20%', width: window.innerWidth < 600 ? '60%' : '35%', justifyContent: 'center', overflow: 'hidden' }}>
                    <CardContent className="textCardModal" style={{ marginTop: 15 }}>
                        <div style={{ justifyContent: 'space-between', flexDirection: 'row', display: 'flex' }}>
                            <Typography style={{ fontSize: 20, color: '#000', fontWeight: '500' }}>Crear categoría</Typography>
                            <CloseIcon onClick={() => { this.setModal(false) }} style={{ fontSize: 20, color: '#000' }} />
                        </div>
                        <div style={{ width: "100%" }}>
                            <TextField
                                id="standard-name"
                                style={{ width: "100%", marginTop: 5, marginBottom: 0, fontSize: 12 }}
                                className="txtTit"
                                placeholder="Nombre de categoría"
                                className={useStyles.textField}
                                value={this.state.nomcat}
                                inputProps={{
                                    onChange: e => {
                                        this.setState({ nomcat: e.target.value });
                                    },
                                    type: "text"
                                }}
                                margin="normal"
                            />
                        </div>
                    </CardContent>
                    <CardContent className="buttomNewNod" style={{ marginTop: 15 }}>
                        <div className="buttonsHed" style={{ width: '100%' }}>
                            <Button
                                style={{ width: '35%' }}
                                className="btn1"
                                onClick={() => {
                                    this.setModal(false);
                                }}
                            >
                                <Typography className="btnNewNov1">CANCELAR</Typography>
                            </Button>
                            <Button
                                style={{ width: '35%' }}
                                className="btn2"
                                onClick={() => {
                                    this._newCat();
                                }}
                            >
                                <Typography className="btnNewNov2">ENVIAR</Typography>
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </Modal>
        );
    };
    setModal2 = prop => {
        this.setState({ open2: prop });
    };
    _modal2 = () => {
        return (
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                className={useStyles.modal}
                open={this.state.open2}
                style={{ overflow: "scroll" }}
                onClose={() => {
                    this.setModal2(false);
                }}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500
                }}
            >
                <Card style={{ margin: "auto", marginTop: '20%', width: window.innerWidth < 600 ? '60%' : '35%', justifyContent: 'center', overflow: 'hidden' }}>
                    <CardContent className="textCardModal" style={{ marginTop: 15 }}>
                        <div style={{ justifyContent: 'space-between', flexDirection: 'row', display: 'flex' }}>
                            <Typography style={{ fontSize: 20, color: '#000', fontWeight: '500' }}>Crear campo de texto</Typography>
                            <CloseIcon onClick={() => { this.setModal2(false) }} style={{ fontSize: 20, color: '#000' }} />
                        </div>
                        <div style={{ width: "100%" }}>
                            <TextField
                                id="standard-name"
                                style={{ width: "100%", marginTop: 5, marginBottom: 0, fontSize: 12 }}
                                className="txtTit"
                                placeholder="Nombre de texto"
                                className={useStyles.textField}
                                value={this.state.textForm}
                                inputProps={{
                                    onChange: e => {
                                        this.setState({ textForm: e.target.value });
                                    },
                                    type: "text"
                                }}
                                margin="normal"
                            />
                        </div>
                    </CardContent>
                    <CardContent className="buttomNewNod" style={{ marginTop: 15 }}>
                        <div className="buttonsHed" style={{ width: '100%' }}>
                            <Button
                                style={{ width: '35%' }}
                                className="btn1"
                                onClick={() => {
                                    this.setModal2(false);
                                }}
                            >
                                <Typography className="btnNewNov1">CANCELAR</Typography>
                            </Button>
                            <Button
                                style={{ width: '35%' }}
                                className="btn2"
                                onClick={() => {
                                    this._newText();
                                }}
                            >
                                <Typography className="btnNewNov2">ENVIAR</Typography>
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </Modal>
        );
    };
    setModal3 = prop => {
        this.setState({ open3: prop });
    };
    _modal3 = () => {
        return (
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                className={useStyles.modal}
                open={this.state.open3}
                style={{ overflow: "scroll" }}
                onClose={() => {
                    this.setModal3(false);
                }}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500
                }}
            >
                <Card style={{ margin: "auto", marginTop: '20%', width: window.innerWidth < 600 ? '60%' : '35%', justifyContent: 'center', overflow: 'hidden' }}>
                    <CardContent className="textCardModal" style={{ marginTop: 15 }}>
                        <div style={{ justifyContent: 'space-between', flexDirection: 'row', display: 'flex' }}>
                            <Typography style={{ fontSize: 20, color: '#000', fontWeight: '500' }}>Crear campo de texto</Typography>
                            <CloseIcon onClick={() => { this.setModal3(false) }} style={{ fontSize: 20, color: '#000' }} />
                        </div>
                        <div style={{ width: "100%" }}>
                            <TextField
                                id="standard-name"
                                style={{ width: "100%", marginTop: 5, marginBottom: 0, fontSize: 12 }}
                                className="txtTit"
                                placeholder="Nombre de texto"
                                className={useStyles.textField}
                                value={this.state.estForm}
                                inputProps={{
                                    onChange: e => {
                                        this.setState({ estForm: e.target.value });
                                    },
                                    type: "text"
                                }}
                                margin="normal"
                            />
                        </div>
                        <div style={{ width: "100%", justifyContent: 'space-around', display: 'flex', flexDirection: 'column' }}>
                            <div style={{ alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'row', width: '100%', display: 'flex', padding: 10 }}>
                                {
                                    this.state.cantEst
                                        ?
                                        <CheckBoxIcon onClick={() => { this.setState({ cantEst: false }) }} style={{ color: '#007aff', fontSize: 25, marginRight: 10 }} />
                                        :
                                        <CheckBoxOutlineBlankIcon onClick={() => { this.setState({ cantEst: true, cantEst2: false }) }} style={{ color: '#ababab', fontSize: 25, marginRight: 10 }} />
                                }
                                <Typography style={{ fontSize: 16, color: '#ababab' }}>2 Estrellas</Typography>
                            </div>
                            <div style={{ alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'row', width: '100%', display: 'flex', padding: 10 }}>
                                {
                                    this.state.cantEst2
                                        ?
                                        <CheckBoxIcon onClick={() => { this.setState({ cantEst2: false }) }} style={{ color: '#007aff', fontSize: 25, marginRight: 10 }} />
                                        :
                                        <CheckBoxOutlineBlankIcon onClick={() => { this.setState({ cantEst: false, cantEst2: true }) }} style={{ color: '#ababab', fontSize: 25, marginRight: 10 }} />
                                }
                                <Typography style={{ fontSize: 16, color: '#ababab' }}>5 Estrellas</Typography>
                            </div>
                        </div>
                    </CardContent>
                    <CardContent className="buttomNewNod" style={{}}>
                        <div className="buttonsHed" style={{ width: '100%' }}>
                            <Button
                                style={{ width: '35%' }}
                                className="btn1"
                                onClick={() => {
                                    this.setModal3(false);
                                }}
                            >
                                <Typography className="btnNewNov1">CANCELAR</Typography>
                            </Button>
                            <Button
                                style={{ width: '35%' }}
                                className="btn2"
                                onClick={() => {
                                    this._newEst();
                                }}
                            >
                                <Typography className="btnNewNov2">ENVIAR</Typography>
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </Modal>
        );
    };
    setModal4 = prop => {
        this.setState({ open4: prop });
    };
    _modal4 = () => {
        return (
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                className={useStyles.modal}
                open={this.state.open4}
                style={{ overflow: "scroll" }}
                onClose={() => {
                    this.setModal4(false);
                }}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500
                }}
            >
                <Card style={{ margin: "auto", marginTop: '20%', width: window.innerWidth < 600 ? '60%' : '35%', justifyContent: 'center', overflow: 'hidden' }}>
                    <CardContent className="textCardModal" style={{ marginTop: 15 }}>
                        <div style={{ justifyContent: 'space-between', flexDirection: 'row', display: 'flex' }}>
                            <Typography style={{ fontSize: 20, color: '#000', fontWeight: '500' }}>Crear multiplechoice</Typography>
                            <CloseIcon onClick={() => { this.setModal4(false) }} style={{ fontSize: 20, color: '#000' }} />
                        </div>
                        <div style={{ width: "100%" }}>
                            <TextField
                                id="standard-name"
                                style={{ width: "100%", marginTop: 5, marginBottom: 0, fontSize: 12 }}
                                className="txtTit"
                                placeholder="Nombre de multiplechoice"
                                className={useStyles.textField}
                                value={this.state.cheForm}
                                inputProps={{
                                    onChange: e => {
                                        this.setState({ cheForm: e.target.value });
                                    },
                                    type: "text"
                                }}
                                margin="normal"
                            />
                        </div>
                        <div style={{ width: "100%", justifyContent: 'space-around', display: 'flex', flexDirection: 'column' }}>
                            <div style={{ alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'row', width: '100%', display: 'flex', padding: 10 }}>
                                {
                                    this.state.op1c
                                        ?
                                        <CheckBoxIcon onClick={() => { this.setState({ op1c: false }) }} style={{ color: '#007aff', fontSize: 25, marginRight: 10 }} />
                                        :
                                        <CheckBoxOutlineBlankIcon onClick={() => { this.setState({ op1c: true }) }} style={{ color: '#ababab', fontSize: 25, marginRight: 10 }} />
                                }
                                <TextField
                                    id="standard-name"
                                    style={{ width: "100%", marginTop: 5, marginBottom: 0, fontSize: 16 }}
                                    className="txtTit"
                                    placeholder="Opción A"
                                    className={useStyles.textField}
                                    value={this.state.op1}
                                    inputProps={{
                                        onChange: e => {
                                            this.setState({ op1: e.target.value });
                                        },
                                        type: "text"
                                    }}
                                    margin="normal"
                                />
                            </div>
                            <div style={{ alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'row', width: '100%', display: 'flex', padding: 10 }}>
                                {
                                    this.state.op2c
                                        ?
                                        <CheckBoxIcon onClick={() => { this.setState({ op2c: false }) }} style={{ color: '#007aff', fontSize: 25, marginRight: 10 }} />
                                        :
                                        <CheckBoxOutlineBlankIcon onClick={() => { this.setState({ op2c: true }) }} style={{ color: '#ababab', fontSize: 25, marginRight: 10 }} />
                                }
                                <TextField
                                    id="standard-name"
                                    style={{ width: "100%", marginTop: 5, marginBottom: 0, fontSize: 16 }}
                                    className="txtTit"
                                    placeholder="Opción B"
                                    className={useStyles.textField}
                                    value={this.state.op2}
                                    inputProps={{
                                        onChange: e => {
                                            this.setState({ op2: e.target.value });
                                        },
                                        type: "text"
                                    }}
                                    margin="normal"
                                />
                            </div>
                        </div>
                    </CardContent>
                    <CardContent className="buttomNewNod" style={{}}>
                        <div className="buttonsHed" style={{ width: '100%' }}>
                            <Button
                                style={{ width: '35%' }}
                                className="btn1"
                                onClick={() => {
                                    this.setModal4(false);
                                }}
                            >
                                <Typography className="btnNewNov1">CANCELAR</Typography>
                            </Button>
                            <Button
                                style={{ width: '35%' }}
                                className="btn2"
                                onClick={() => {
                                    this._newCheck();
                                }}
                            >
                                <Typography className="btnNewNov2">ENVIAR</Typography>
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </Modal>
        );
    };

    _newCat = () => {
        this.setState({ load: true })
        this.f.formulario.push(
            {
                name: this.state.nomcat,
                items: [],
                id: 3
            }
        )

        this.setState({ catdis: true, textdis: false, estdis: false, chedis: false, nomcat: '', open1: !this.state.open1 }, () => {
            setTimeout(() => {
                this.setState({ load: false })
            }, 2000)
        })
    }
    _newText = () => {
        this.setState({ load: true })
        if (this.state.textForm != '') {
            for (let i in this.f.formulario) {
                if (this.f.formulario[i].id === 3) {
                    this.f.formulario[i].items.push({
                        name: this.state.textForm,
                        type: 'texto',
                        valor: 'Escribir'
                    })
                }
            }
            this.setState({ textdis: true, textForm: '', open2: !this.state.open2 }, () => {
                setTimeout(() => {
                    this.setState({ load: false })
                }, 2000)
            })
        }
    }
    _newEst = () => {
        if ((this.state.cantEst == true || this.state.cantEst2 == true) && this.state.estForm != '') {
            this.setState({ load: true })
            for (let i in this.f.formulario) {
                if (this.f.formulario[i].id === 3) {
                    this.f.formulario[i].items.push({
                        name: this.state.estForm,
                        type: 'estrella',
                        valor: 0,
                        valuable: this.state.cantEst ? 2 : 5
                    })
                }
            }
            this.setState({ estdis: true, estForm: '', open3: !this.state.open3 }, () => {
                setTimeout(() => {
                    this.setState({ load: false })
                }, 2000)
            })
        }
    }
    _newCheck = () => {
        if ((this.state.op1 != '' || this.state.op2 != '') && (this.state.op1c == true || this.state.op2c == true) && this.state.cheForm != '') {
            this.setState({ load: true })
            const array = []
            if (this.state.op1c) {
                array.push({
                    name: this.state.op1,
                    check: false
                })
                if (this.state.op2c) {
                    array.push({
                        name: this.state.op2,
                        check: false
                    })
                }
            } else if (this.state.op2c) {
                array.push({
                    name: this.state.op2,
                    check: false
                })
                if (this.state.op1c) {
                    array.push({
                        name: this.state.op1,
                        check: false
                    })
                }
            }
            for (let i in this.f.formulario) {
                if (this.f.formulario[i].id === 3) {
                    this.f.formulario[i].items.push({
                        name: this.state.cheForm,
                        type: 'check',
                        items: array
                    })
                }
            }
            this.setState({ chedis: true, cheForm: '', open4: !this.state.open4 }, () => {
                setTimeout(() => {
                    this.setState({ load: false })
                }, 2000)
            })
        }
    }
    _types = (item) => {
        if (item.type == 'estrella') {
            var statement = [];
            var valor = parseInt(item.valor);
            var estrellas = parseInt(item.valuable);
            if (valor > 0) {
                statement.push(<HighlightOffIcon style={{ color: '#ababab', fontSize: 15 }} />)
                for (var valorate = 0; valor > valorate; valorate++) {
                    statement.push(<StarIcon style={{ color: '#007aff', fontSize: 15 }} />)
                }
                for (var gila = item.valor; estrellas > gila; gila++) {
                    statement.push(<StarBorderIcon style={{ color: '#ababab', fontSize: 15 }} />)
                }
            } else {
                for (var valorate = 0; item.valuable > valorate; valorate++) {
                    statement.push(<StarBorderIcon style={{ color: '#ababab', fontSize: 15 }} />)
                }
            }
            return (<div style={{ flexDirection: 'row', justifyContent: 'flex-start', display: 'flex', backgroundColor: '#fff', width: '90%', paddingLeft: 20, paddingBottom: 5 }}>
                {
                    statement.map((item, i) => {
                        return (
                            <div key={i}>{item}</div>
                        )
                    })
                }
            </div>);
        } else if (item.type == 'texto') {
            if (item.valor == '') {
            } else {
                return (<div style={{ flexDirection: 'row', justifyContent: 'flex-start', display: 'flex', backgroundColor: '#fff', width: '90%', paddingLeft: 20, paddingBottom: 5 }}>
                    <Typography style={{ color: '#ababab', fontSize: 10, textAlign: 'left' }}>{item.valor}</Typography>
                </div>
                )
            }
        }
    }
    _types2 = (item) => {
        if (item.type == 'check') {
            var statement = [];
            if (item.items.length > 0) {
                for (let lala = 0; lala < item.items.length; lala++) {
                    const element = item.items[lala];
                    if (element.check) {
                        statement.push(
                            <div style={{ justifyContent: 'space-between', flexDirection: 'row', backgroundColor: '#fff', display: 'flex' }}>
                                <Typography style={{ color: '#ababab', fontSize: 10 }}>{element.name}</Typography>
                                <CheckBoxIcon style={{ fontSize: 15, color: '#007aff' }} />
                            </div>
                        )
                    } else {
                        statement.push(
                            <div style={{ justifyContent: 'space-between', flexDirection: 'row', backgroundColor: '#fff', display: 'flex' }}>
                                <Typography style={{ color: '#ababab', fontSize: 10 }}>{element.name}</Typography>
                                <CheckBoxOutlineBlankIcon style={{ fontSize: 15, color: '#ababab' }} />
                            </div>
                        )
                    }
                }
            }
            return (<div style={{ flexDirection: 'column', justifyContent: 'flex-start', display: 'flex', backgroundColor: '#fff', width: '90%', paddingLeft: 20, paddingBottom: 5, paddingRight: 15 }}>
                {
                    statement.map((item, i) => {
                        return (
                            <div key={i}>{item}</div>
                        )
                    })
                }
            </div>);
        }
    }

    render() {
        return (
            <React.Fragment>
                <CssBaseline />
                <Header />
                <Toolbar />
                <div style={{ paddingTop: window.innerWidth < 600 ? 70 : 10, paddingBottom: 70 }}>
                    {this._content()}
                    {this._subContent()}
                    {this._cardAdd()}
                    {this._cardAddmob()}
                    {this._listSubCard()}
                    {this._modal()}
                    {this._modal2()}
                    {this._modal3()}
                    {this._modal4()}
                </div>
            </React.Fragment>
        );
    }
}

function Header(props) {
    return (
        <ElevationScroll {...props}>
            <AppBar>
                <Toolbar style={{ backgroundColor: '#fff', paddingLeft: 0, paddingRight: 0 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} style={{ padding: 20, paddingBottom: 10 }}>
                            <div>
                                <Link to="/">
                                    <img src={logo} className="App-logo" alt="logo" />
                                </Link>
                            </div>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justify="space-around"
                            alignItems="center"
                            xs={12} sm={6}
                            style={{ padding: 10, flexWrap: 'nowrap', justifyContent: 'center', marginBottom: 10 }}>

                            <div style={{ width: '40%', marginRight: 5 }}>
                                <Link to="/">
                                    <Button className="btn1" style={{ width: '100%', padding: 0, margin: 0, backgroundColor: '#fff' }}>
                                        <ArrowBack className="btn1icon" style={{}} />
                                        <Typography className="txtb1" style={{ fontSize: 12 }}>Seguir probando</Typography>
                                    </Button>
                                </Link>
                            </div>
                            <div style={{ width: '40%', marginLeft: 5 }}>
                                <Link to="/finish">
                                    <Button className="btn2" style={{ width: '100%', padding: 0, margin: 0, backgroundColor: '#F50027' }}>
                                        <Typography className="txtb2">Probar 14 días gratis</Typography>
                                    </Button>
                                </Link>
                            </div>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        </ElevationScroll>
    );
}
function ElevationScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined
    });
    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0
    });
}
const Fade = React.forwardRef(function Fade(props, ref) {
    const { in: open, children, onEnter, onExited, ...other } = props;
    const style = useSpring({
        from: { opacity: 0 },
        to: { opacity: open ? 1 : 0 },
        onStart: () => {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: () => {
            if (!open && onExited) {
                onExited();
            }
        }
    });
    return (
        <animated.div
            ref={ref}
            style={[
                style,
                { flexDirection: "row", flex: 1, justifyContent: "center" }
            ]}
            {...other}
        >
            {children}
        </animated.div>
    );
});
ElevationScroll.propTypes = {
    children: PropTypes.element.isRequired,
    /**
    * Injected by the documentation to work in an iframe.
    * You won't need it on your project.
    */
    window: PropTypes.func
};

const useStyles = makeStyles(theme => ({
    card: {
        width: "65%",
        marginBottom: 15,
        height: 300
    },
    media: {
        height: 300,
        paddingTop: "56.25%" // 16:9
    },
    expand: {
        transform: "rotate(0deg)",
        marginLeft: "auto",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        })
    },
    expandOpen: {
        transform: "rotate(180deg)"
    },
    avatar: {
        backgroundColor: red[500]
    },
    modal: {
        // display: 'flex',
        // alignItems: 'center',
        // justifyContent: 'center',
        // flexDirection: 'row',
        // flex: 1,
        justifyContent: "center",
        overflow: "scroll"
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "2px solid #000",
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3)
    },
    textField: {
        width: "100%",
        marginTop: 0,
        fontSize: 15
    }
}));